import dayjs from "dayjs";
import { If } from "shared/components/control-statements";
import styles from "styles/pages/reports/reports.module.scss";

export default function UsageRecord({
  data = [],
  handlePageChange,
  totalPages,
  currentPage,
}) {
  if (!data) return null;

  const formatPhone = (phone) => {
    if (!phone) return null;
    const match = phone.match(/^\+55\s?(\d{2})\s?(\d{5}-\d{4})$/);
    if (!match) return phone;
    const [, ddd, number] = match;
    return `(${ddd}) ${number}`;
  };

  return (
    <div className={styles.box2}>
      <div className="d-flex align-center justify-between px-20">
        <div className="d-flex align-center gap-5">
          <p className={styles.label}>Registros de usos de cupom</p>
        </div>
      </div>

      <div className={styles.hairline} />

      <div className={styles.tableFull}>
        <table className="w-100">
          <thead>
            <tr>
              <th>DATA E HORA</th>
              <th>CÓDIGO DO CUPOM</th>
              <th>MARCA</th>
              <th>UNIDADE</th>
              <th>TELEFONE DO CLIENTE</th>
              <th>CADASTRO DO CLIENTE</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              return (
                <tr key={index}>
                  <td>
                    <div className="d-flex align-center">
                      <p className={styles.value}>
                        <If cond={item.coupon_used_at}>
                          {dayjs(item.coupon_used_at).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                        </If>
                      </p>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-center">
                      <p className={styles.value}>{item.coupon_code}</p>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-center">
                      <p className={styles.value}>{item.brand_name || "---"}</p>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-center">
                      <p className={styles.value}>{item.unit_name || "---"}</p>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-center">
                      <p className={styles.value}>
                        {formatPhone(item.customer_phone)}
                      </p>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-center">
                      <If cond={item.customer_created_at}>
                        {dayjs(item.customer_created_at).format("DD/MM/YYYY")}
                      </If>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className={styles.pagination}>
          <button
            disabled={currentPage === 1 || !totalPages}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            <i className="fal fa-arrow-left" />
          </button>

          <span className={styles.page}>
            Página <strong>{currentPage || 1}</strong> de{" "}
            <strong>{totalPages || 1}</strong>
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            <i className="fal fa-arrow-right" />
          </button>
        </div>
      </div>
    </div>
  );
}
